// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function PseudoJoin(props) {
  var __with_ = props.with_;
  var __as_ = props.as_;
  var as_ = __as_ !== undefined ? __as_ : "span";
  var with_ = __with_ !== undefined ? __with_ : " / ";
  var joined = Utils.$$Array.pseudoJoin(with_, undefined, props.items);
  if (as_ === "p") {
    return JsxRuntime.jsx("p", {
                children: joined
              });
  } else if (as_ === "div") {
    return JsxRuntime.jsx("div", {
                children: joined
              });
  } else {
    return JsxRuntime.jsx("span", {
                children: joined
              });
  }
}

var make = PseudoJoin;

exports.make = make;
/* Utils Not a pure module */
